"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { GroupsRequestParams } from "@/entities/IGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { Mutable, NonNullableNotRequired } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import SelectGroupModalHeader from "./SelectGroupModalHeader";
import SelectGroupModalSearch from "./SelectGroupModalSearch";
import SelectGroupModalItems from "./SelectGroupModalItems";
const DEFAULT_CONTAINER_CLASSES = "sm:tw-max-w-md tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500";
const DEFAULT_BODY_CLASSES = "tw-h-64 tw-overflow-y-auto tw-mt-4 tw-px-4 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300";
type SelectGroupSearchPanelProps = {
  readonly onClose: () => void;
  readonly onGroupSelect: (group: ApiGroupFull) => void;
  readonly containerClassName?: string | undefined;
  readonly bodyClassName?: string | undefined;
};
export default function SelectGroupSearchPanel(t0) {
  const $ = _c(36);
  const {
    onClose,
    onGroupSelect,
    containerClassName,
    bodyClassName
  } = t0;
  let t1;
  if ($[0] !== containerClassName) {
    t1 = [DEFAULT_CONTAINER_CLASSES, containerClassName].filter(Boolean);
    $[0] = containerClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const containerClasses = t1.join(" ");
  let t2;
  if ($[2] !== bodyClassName) {
    t2 = [DEFAULT_BODY_CLASSES, bodyClassName].filter(Boolean);
    $[2] = bodyClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const bodyClasses = t2.join(" ");
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      group_name: null,
      author_identity: null
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [filters, setFilters] = useState(t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => {
      setFilters(prev => ({
        ...prev,
        author_identity: value
      }));
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onUserSelect = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value_0 => {
      setFilters(prev_0 => ({
        ...prev_0,
        group_name: value_0
      }));
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const onFilterNameSearch = t5;
  let t6;
  if ($[7] !== filters) {
    t6 = [QueryKey.GROUPS, filters];
    $[7] = filters;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== filters.author_identity || $[10] !== filters.group_name) {
    t7 = async () => {
      const params = {};
      if (filters.group_name) {
        params.group_name = filters.group_name;
      }
      if (filters.author_identity) {
        params.author_identity = filters.author_identity;
      }
      return await commonApiFetch({
        endpoint: "groups",
        params
      });
    };
    $[9] = filters.author_identity;
    $[10] = filters.group_name;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = {
      queryKey: t6,
      queryFn: t7,
      placeholderData: keepPreviousData
    };
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const {
    data,
    isFetching
  } = useQuery(t8);
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const [groups, setGroups] = useState(t9);
  let t10;
  let t11;
  if ($[16] !== data) {
    t10 = () => {
      if (data?.length) {
        setGroups(data);
      } else {
        setGroups([]);
      }
    };
    t11 = [data];
    $[16] = data;
    $[17] = t10;
    $[18] = t11;
  } else {
    t10 = $[17];
    t11 = $[18];
  }
  useEffect(t10, t11);
  let t12;
  if ($[19] !== onClose) {
    t12 = <SelectGroupModalHeader onClose={onClose} />;
    $[19] = onClose;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== filters.author_identity || $[22] !== filters.group_name) {
    t13 = <SelectGroupModalSearch groupName={filters.group_name} groupUser={filters.author_identity} onUserSelect={onUserSelect} onFilterNameSearch={onFilterNameSearch} />;
    $[21] = filters.author_identity;
    $[22] = filters.group_name;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== groups || $[25] !== isFetching || $[26] !== onGroupSelect) {
    t14 = <SelectGroupModalItems groups={groups} loading={isFetching} onGroupSelect={onGroupSelect} />;
    $[24] = groups;
    $[25] = isFetching;
    $[26] = onGroupSelect;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== bodyClasses || $[29] !== t14) {
    t15 = <div className={bodyClasses}>{t14}</div>;
    $[28] = bodyClasses;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== containerClasses || $[32] !== t12 || $[33] !== t13 || $[34] !== t15) {
    t16 = <div className={containerClasses}>{t12}{t13}{t15}</div>;
    $[31] = containerClasses;
    $[32] = t12;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}